import {Approval} from '@/Core/mobx/ParameterStore/Approval';
import {Parameter} from '@/Core/mobx/ParameterStore/Parameter';
import {Grid} from '@material-ui/core';
import {observer} from 'mobx-react-lite';
import {CategoryCard} from '../PreApprovals/CategoryCard';
import {TextBox} from '@/Core/UI';
import {SelectInputElement} from '../PreQualification/Components/SelectInputElement';
import {fieldOptions} from '@/Core/mobx/ParameterStore/ApprovalXref';
import {useEffect} from 'react';
import RootStore from '@/Core/mobx/RootStore';

type CarrierPortalInformationProps = {
    valueChanged: (p?: Parameter, value?: any) => void;
    parameters: Approval;
    index: number;
    setCategory: (entry: string) => void;
    setCompleted?: (completed: boolean) => void;
};

const CarrierPortalInformation = observer(
    ({valueChanged, parameters, setCategory, index, setCompleted}: CarrierPortalInformationProps) => {
        const required = (value?: string) => (
            <span>
                {value && value} <span style={{color: 'red'}}>*</span>
            </span>
        );
        const {parameterStore} = RootStore.agentPortalStore;

        useEffect(() => {
            if (setCompleted) {
                setCompleted(parameters.policyNumber?.value !== '' && parameters.applicationStatus?.value !== '');
            }
        }, [setCompleted, parameters.policyNumber?.value, parameters.applicationStatus?.value]);

        return (
            <CategoryCard title={'Carrier Portal Information'} setCategory={setCategory} index={index}>
                <Grid item xs={4}>
                    <TextBox
                        id="policyNumber"
                        label={required('Policy Number')}
                        value={parameters.policyNumber?.value}
                        onChange={(value) =>
                            parameterStore.onValueChangedPreApproval(
                                {...parameters.policyNumber, name: 'policyNumber'},
                                value,
                            )
                        }
                    />
                </Grid>
                <Grid item xs={4}>
                    <SelectInputElement
                        param={{
                            label: 'Application Status',
                            name: 'applicationStatus',
                            options: fieldOptions.applicationStatus.options,
                            ...parameters.applicationStatus,
                        }}
                        required={required('')}
                        valueChanged={valueChanged}
                    />
                </Grid>
            </CategoryCard>
        );
    },
);

export default CarrierPortalInformation;
